import React, {useState, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import axios from 'axios';
import {
    Button,
    Container,
    FormControlLabel,
    Paper,
    Switch,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    MenuItem,
    Select,
    Tooltip, Dialog, DialogTitle, IconButton, DialogContent, Typography
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./AddEmployeeForm.css";
import "./AddInputForm.css"
import AddIntegratedInput from "./AddIntegredetInput";
import {Autocomplete} from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import AddNewInputTypeFormForAll from "./AddNewInputTypeFormForAll";
import DictionaryTypeAdder from "./DictionaryTypeAdder";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const SCROLL_THRESHOLD = 250; // Distance from the edge to start scrolling
const SCROLL_SPEED = 20

const AddInputForm = () => {
    const query = useQuery();
    const caseId = parseInt(query.get("id"), 10);
    const [inputTypes, setInputTypes] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [descriptionDropDown, setDescriptionDropDown] = useState('');
    const [isRequired, setIsRequired] = useState(false);
    const [hasDeadline, setHasDeadline] = useState(false);
    const [hasFile, setHasFile] = useState(false);
    const [visibleOnTable, setVisibleOnTable] = useState(false);
    const [visibleOnTableForUser, setVisibleOnTableForUser] = useState(false);
    const [canBeDeleted, setCanBeDeleted] = useState(false);
    const [visibleOnTableDropDown, setVisibleOnTableDropDown] = useState(false);
    const [visibleOnTableForUserDropDown, setVisibleOnTableForUserDropDown] = useState(false);
    const [canBeDeletedDropDown, setCanBeDeletedDropDown] = useState(false);
    const [isInternal, setIsInternal] = useState(false);
    const [isInternalDropDown, setIsInternalDropDown] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteInputTypeId, setDeleteInputTypeId] = useState(null);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [isEditing, setIsEditing] = useState(null);
    const [dictionaryTypes, setDictionaryTypes] = useState([]);
    const [isDropdownModalOpen, setIsDropdownModalOpen] = useState(false);
    const [selectedType, setSelectedType] = useState({});
    const [isDropdownRequired, setIsDropdownRequired] = useState(false);
    const [draggedItem, setDraggedItem] = useState(null);
    const [droppedItem, setDroppedItem] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [inputType, setInputType] = useState('0');
    const [data, setData] = useState([]);
    const [integration, setIntegration] = useState(false);
    const [unicId, setUnicId] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDict, setOpenDict] = useState(false);

    const [passwordEntered, setPasswordEntered] = useState(false);
    const [keySequence, setKeySequence] = useState('');
    const identificationFields = ["ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი", "საიდენტიფიკაციო ნომერი", "ობიექტის მფლობელის საიდენტიფიკაციო კოდი"]
    const secretCode = '27015';
    const tableContainerRef = useRef(null);
    const [editableInputType, setEditableInputType] = useState({
        title: '',
        description: '',
        required: false,
        internal: false,
        integration: false,
        hasDeadline: false,
        hasFile: false,
        unicId: false
    });


    const onClose = () => {
        setOpen(false);
    }

    const onCloseDict = () => {
        setOpenDict(false);
    }

    const checkIfUniqueIDExists = (excludeId) => {
        return inputTypes.some(inputType => inputType.unicId && inputType.id !== excludeId);
    }
    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key;
            const updatedSequence = (keySequence + key).slice(-5); // Keep the last 5 characters
            setKeySequence(updatedSequence);

            if (updatedSequence === secretCode) {
                setPasswordEntered(!passwordEntered)
            }
        };

        document.addEventListener('keypress', handleKeyPress);

        return () => {
            document.removeEventListener('keypress', handleKeyPress);
        };
    }, [keySequence]);

    const fetchData = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllGlobalInputTypes?PageSize=1000&Page=0`);
        const jsonResponse = await response.json();
        if (jsonResponse.success) {
            const filteredData = jsonResponse.data.result.filter(item =>
                !inputTypes.some(inputType => inputType.title === item.name)
            );
            setData(filteredData);
        }
    };

    useEffect(() => {
        void fetchData();
    }, []);

    const refreshGlobalInputTypes = async () => {
        void fetchData();
    }

    const handleDragEnter = (e, index) => {
        const row = e.currentTarget;
        if (row && draggedItem !== index) {
            row.style.backgroundColor = "#d0e0f0";
        }
    };

    const handleDragLeave = (e) => {
        const row = e.currentTarget;
        if (row) {
            row.style.backgroundColor = "";
        }
    };
    const handleDragEnd = () => {
        const rows = document.querySelectorAll(".MuiTableRow-root");
        rows.forEach((row) => {
            row.style.backgroundColor = "";
        });

        setDraggedItem(null);
        setDroppedItem(null);
        setDragOverIndex(null);
    };


    const openDropdownSubmitModal = () => {
        setIsDropdownModalOpen(true);
    };

    const confirmDropdownSubmit = async () => {
        if (!selectedType.id) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
            setIsDropdownModalOpen(false);
            return;
        }

        const newSortValue = inputTypes.length + 1;

        const newDropdownInputType = {
            title: selectedType.typesName,
            value: selectedType.id.toString(),
            type: 1,
            required: isDropdownRequired,
            caseId: caseId,
            sort: newSortValue,
            description: descriptionDropDown,
            internal: isInternalDropDown,
            canBeDeleted: canBeDeletedDropDown,
            visibleOnTable: visibleOnTableDropDown,
            visibleOnTableForUser: visibleOnTableForUserDropDown
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewInputType`, newDropdownInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            clearForm();
            await fetchInputTypes();
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsDropdownModalOpen(false);
        }
    };

    const refreshInputTypes = () => {
        void fetchInputTypes();
    };
    useEffect(() => {
        void fetchDictionaryTypes();
    }, []);

    const fetchDictionaryTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
            setDictionaryTypes(response.data.data);
        } catch (error) {
        }
    };

    const refreshDictonaries = () => {
        void fetchDictionaryTypes();
    };

    useEffect(() => {
        void fetchInputTypes();
    }, [caseId]);


    const clearForm = () => {
        setTitle('');
        setDescription('')
        setDescriptionDropDown('')
        setIsRequired(false);
        setIsInternal(false);
        setHasFile(false);
        setHasDeadline(false);
        setUnicId(false);
    };

    const openSubmitModal = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const confirmSubmit = async () => {

        if (unicId && checkIfUniqueIDExists(null)) {
            setAlert({show: true, message: 'Unique ID უკვე არსებობს', type: 'error'});
            return;
        }


        const newSortValue = inputTypes.length + 1;


        const newInputType = {
            title,
            value: "",
            type: parseInt(inputType, 10),
            required: isRequired,
            caseId: caseId,
            sort: newSortValue,
            integration: integration ? 1 : 0,
            description: description,
            internal: isInternal,
            hasFile: hasFile,
            hasDeadline: hasDeadline,
            unicId: unicId,
            canBeDeleted: canBeDeleted,
            visibleOnTable: visibleOnTable,
            visibleOnTableForUser: visibleOnTableForUser

        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewInputType`, newInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            clearForm();
            await fetchInputTypes();
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsModalOpen(false);
        }
    };


    const fetchInputTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllInputType`);
            const filteredAndSortedInputTypes = response.data.data
                .filter(inputType => inputType.caseId === caseId)
                .sort((a, b) => a.sort - b.sort);
            setInputTypes(filteredAndSortedInputTypes);
        } catch (error) {
        }
    };


    const handleEdit = (inputType) => {
        setIsEditing(inputType.id);
        setEditableInputType({
            ...inputType,
            description: inputType.description,
            internal: inputType.internal,
            required: inputType.internal ? false : inputType.required,
            hasDeadline: inputType.hasDeadline,
            hasFile: inputType.hasFile
        });
    };


    const cancelEdit = () => {
        setIsEditing(null);
        setEditableInputType({
            title: '',
            description: '',
            required: false,
            internal: false,
            integration: false,
        });
    };
    const handleSave = async (inputTypeId) => {

        if (editableInputType.unicId && checkIfUniqueIDExists(inputTypeId)) {
            setAlert({show: true, message: 'Unique ID უკვე არსებობს', type: 'error'});
            return;
        }

        const updatedInputType = {
            ...editableInputType,
            id: inputTypeId,
            caseId: caseId,
            description: editableInputType.description,
            internal: editableInputType.internal,
            integration: editableInputType.integration,
        };

        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditInputType`, updatedInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
            await fetchInputTypes();
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsEditing(null);
        }
    };

    const openDeleteModal = (inputTypeId) => {
        setDeleteInputTypeId(inputTypeId);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteInputType`, {id: deleteInputTypeId});
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});

            const remainingInputTypes = inputTypes.filter(inputType => inputType.id !== deleteInputTypeId);

            remainingInputTypes.sort((a, b) => a.sort - b.sort);

            for (let i = 0; i < remainingInputTypes.length; i++) {
                if (remainingInputTypes[i].sort !== i + 1) {
                    const updatedInputType = {
                        ...remainingInputTypes[i],
                        sort: i + 1,
                    };

                    await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditInputType`, updatedInputType);

                    remainingInputTypes[i].sort = i + 1;
                }
            }

            setInputTypes(remainingInputTypes);

        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsDeleteModalOpen(false);
        }
    };

    const handleDragStart = (e, index) => {
        setDraggedItem(index);
    };


    const handleDrop = async (e, dropIndex) => {
        e.preventDefault();
        if (draggedItem === null || draggedItem === dropIndex) return;

        let newInputTypes = [...inputTypes];
        const draggedItemObj = newInputTypes.splice(draggedItem, 1)[0];
        newInputTypes.splice(dropIndex, 0, draggedItemObj);

        newInputTypes = newInputTypes.map((item, index) => ({
            ...item,
            sort: index + 1,
        }));

        setInputTypes(newInputTypes);

        try {
            await Promise.all(
                newInputTypes.map((inputType) =>
                    axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditInputType`, {
                        caseId: caseId,
                        id: inputType.id,
                        title: inputType.title,
                        description: inputType.description,
                        required: inputType.required,
                        internal: inputType.internal,
                        integration: inputType.integration,
                        sort: inputType.sort,
                        unicId: inputType.unicId,
                        hasFile: inputType.hasFile,
                        hasDeadline: inputType.hasDeadline,
                        integrationPropertyName: inputType.integrationPropertyName,
                        value: inputType.value,
                        type: inputType.type,
                    })
                )
            );
            setAlert({ show: true, message: "ოპერაცია წარმატებით დასრულდა", type: "success" });
        } catch (error) {
            setAlert({
                show: true,
                message: "Failed to update the order. Please try again.",
                type: "error",
            });
            await fetchInputTypes();
        }

        setDraggedItem(null);
        setDroppedItem(null);
        setDragOverIndex(null);
    };


    const isSubmitDisabled = title.trim() === '';

    return (
        <div className="add-dov-type-form">
            <Container style={{marginTop: "100px"}}>
                <Paper>
                    <form style={{display: 'flex', justifyContent: 'space-between', gap: 100}}
                          onSubmit={openSubmitModal}>

                        <div className={"add-form-input"}>
                            <div className={"AddIntegratedInput-container"}>
                                <AddIntegratedInput sortIncrement={inputTypes.length} onAdded={refreshInputTypes}/>
                            </div>
                            <div className={"AddIntegratedInput-container"}>
                                <Button onClick={() => {setOpen(true)}}>ველის დამატება</Button>
                            </div>
                            <div>
                            </div>
                            <div className={"add-form-input-title"}>შესაყვანი ველის დამატება</div>
                            <Autocomplete
                                fullWidth
                                options={data.filter((item) => item.value === "")}
                                getOptionLabel={(option) => option.name || ''}
                                value={data.find(item => item.name === title) || null}
                                onChange={(event, newValue) => {
                                    setTitle(newValue ? newValue.name : '');
                                }}
                                noOptionsText="არაფერი მოიძებნა"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="აირჩიეთ სახელი"
                                        margin="normal"
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} style={{height: 'auto', padding: '8px', margin: 0}}>
                                        {option.name}
                                    </li>
                                )}
                            />

                            <TextField
                                label="აღწერა"
                                multiline
                                rows={2}
                                fullWidth
                                style={{marginBottom: 24}}
                                margin="normal"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <Select
                                value={inputType}
                                onChange={(e) => setInputType(e.target.value)}
                                fullWidth
                                displayEmpty
                                style={{marginBottom: 24}}
                                margin="normal"
                            >
                                <MenuItem value="0">სტანდარტული</MenuItem>
                                <MenuItem value="2">დიდი</MenuItem>
                                <MenuItem value="5">თარიღი</MenuItem>
                                <MenuItem value="6">ტელეფონი</MenuItem>
                                <MenuItem value="7">ელ-ფოსტა</MenuItem>
                            </Select>
                            <div style={{display: "flex", gap: 5}}>
                                <div className={"external-switches"}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isRequired}
                                                onChange={(e) => setIsRequired(e.target.checked)}
                                                disabled={isInternal || hasFile || hasDeadline}
                                            />
                                        }
                                        label="სავალდებულო"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={canBeDeleted}
                                                onChange={(e) => setCanBeDeleted(e.target.checked)}
                                            />
                                        }
                                        label="შეუძლებელია წაშლა"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={integration}
                                                onChange={(e) => setIntegration(e.target.checked)}
                                                disabled={isInternal || hasFile || hasDeadline}
                                            />
                                        }
                                        label="საიდენტიფიკაციო ველი"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={unicId}
                                                onChange={(e) => setUnicId(e.target.checked)}
                                                disabled={isInternal || hasFile || hasDeadline}
                                            />
                                        }
                                        label="Unique ID"
                                    />
                                </div>
                                <div className={"external-switches"}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isInternal}
                                                disabled={hasFile || hasDeadline}
                                                onChange={(e) => {
                                                    setIsInternal(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsRequired(false);
                                                        setIntegration(false);
                                                        setUnicId(false);

                                                    }
                                                }}
                                            />
                                        }
                                        label="თანამშრომლის ველი"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={hasDeadline}
                                                onChange={(e) => {
                                                    setHasDeadline(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsRequired(false);
                                                        setIntegration(false);
                                                        setIsInternal(true)
                                                        setUnicId(false)
                                                    }
                                                }}
                                            />
                                        }
                                        label="თარიღი"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={hasFile}
                                                onChange={(e) => {
                                                    setHasFile(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsRequired(false);
                                                        setIntegration(false);
                                                        setIsInternal(true)
                                                        setUnicId(false)
                                                    }
                                                }}
                                            />
                                        }
                                        label="ებმევა ფაილი"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={visibleOnTable}
                                                disabled={isInternal}
                                                onChange={(e) => {

                                                    setVisibleOnTable(e.target.checked);
                                                }}
                                            />
                                        }
                                        label="ჩანს თანამშრომლის გვერდზე"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled={isInternal}
                                                checked={visibleOnTableForUser}
                                                onChange={(e) => {

                                                    setVisibleOnTableForUser(e.target.checked);
                                                }}
                                            />
                                        }
                                        label="ჩანს მომხმარებლის გვერდზე"
                                    />

                                </div>
                            </div>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                style={{marginTop: 16}}
                                disabled={isSubmitDisabled}
                            >
                                დამატება
                            </Button>
                        </div>
                        <div className={"add-form-input"}>
                            <div>
                                <div className={"add-form-input-title"}>ცნობარის დამატება</div>
                                <Button onClick={() => setOpenDict(true)}> ცნობარის რეგისტრაცია</Button>
                                <Autocomplete
                                    fullWidth
                                    options={dictionaryTypes}
                                    getOptionLabel={(option) => option.typesName || ''}
                                    value={dictionaryTypes.find(item => item.id === selectedType.id) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedType(newValue || {});
                                    }}
                                    noOptionsText="არაფერი მოიძებნა"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="აირჩიეთ ცნობარი"
                                            margin="normal"
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{height: 'auto', padding: '8px', margin: 0}}>
                                            {option.typesName}
                                        </li>
                                    )}
                                />

                                <TextField
                                    label="აღწერა"
                                    fullWidth
                                    multiline
                                    rows={2}
                                    margin="normal"
                                    value={descriptionDropDown}
                                    onChange={(e) => setDescriptionDropDown(e.target.value)}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isDropdownRequired}
                                            onChange={(e) => setIsDropdownRequired(e.target.checked)}
                                            disabled={isInternalDropDown}
                                        />
                                    }
                                    label="სავალდებულო"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isInternalDropDown}
                                            onChange={(e) => {
                                                setIsInternalDropDown(e.target.checked);
                                                if (e.target.checked) {
                                                    setIsDropdownRequired(false);
                                                    setVisibleOnTable(true);
                                                    setVisibleOnTableForUser(false);
                                                    setVisibleOnTableDropDown(true);
                                                    setVisibleOnTableForUserDropDown(false);
                                                }
                                            }}
                                        />
                                    }
                                    label="თანამშრომლის ველი"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={canBeDeletedDropDown}
                                            onChange={(e) => setCanBeDeletedDropDown(e.target.checked)}
                                        />
                                    }
                                    label="შეუძლებელია წაშლა"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={visibleOnTableDropDown}
                                            disabled={isInternal}
                                            onChange={(e) => {

                                                setVisibleOnTableDropDown(e.target.checked);
                                            }}
                                        />
                                    }
                                    label="ჩანს თანამშრომლის გვერდზე"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={isInternalDropDown}
                                            checked={visibleOnTableForUserDropDown}
                                            onChange={(e) => {

                                                setVisibleOnTableForUserDropDown(e.target.checked);
                                            }}
                                        />
                                    }
                                    label="ჩანს მომხმარებლის გვერდზე"
                                />
                            </div>
                            <Button
                                type="button"
                                color="primary"
                                variant="contained"
                                style={{marginTop: 16}}
                                onClick={openDropdownSubmitModal}
                                disabled={!selectedType.id}
                            >
                                დამატება
                            </Button>
                        </div>

                    </form>

                    <TableContainer ref={tableContainerRef} style={{ maxHeight: "800px", overflowY: "auto" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>სახელი</TableCell>
                                    <TableCell>აღწერა</TableCell>
                                    <TableCell>სავალდებულო</TableCell>
                                    <TableCell>თანამშრომლის ველი</TableCell>
                                    <TableCell>ტიპი</TableCell>
                                    <TableCell>თარიღი</TableCell>
                                    <TableCell>ებმევა ფაილი</TableCell>
                                    <TableCell>Unique ID</TableCell>
                                    <TableCell>ჩანს მომხმარებლის გვერდზე</TableCell>
                                    <TableCell>ჩანს თანამშრომლის გვერდზე</TableCell>
                                    <TableCell>შეუძლებელია წაშლა</TableCell>
                                    <TableCell style={{position: 'sticky', right: 0, background: 'white', zIndex: 2}}>ქმედება</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {inputTypes.map((inputType, index) => (
                                    <TableRow
                                        key={inputType.id}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDragEnter={(e) => handleDragEnter(e, index)}
                                        onDragLeave={handleDragLeave} // No need to pass index here
                                        onDrop={(e) => handleDrop(e, index)}
                                        onDragEnd={handleDragEnd}
                                        className={`${draggedItem === index ? "row-being-dragged" : ""} ${droppedItem === index ? "row-dropped" : ""} ${dragOverIndex === index ? "drag-over" : ""}`}
                                    >
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <TextField
                                                    value={editableInputType.title}
                                                    onChange={(e) => setEditableInputType({
                                                        ...editableInputType,
                                                        title: e.target.value
                                                    })}
                                                    fullWidth
                                                />
                                            ) : (
                                                inputType.title
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <TextField
                                                    value={editableInputType.description}
                                                    onChange={(e) => setEditableInputType({
                                                        ...editableInputType,
                                                        description: e.target.value,
                                                    })}
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                />
                                            ) : inputType.description && inputType.description.length > 30 ? (
                                                <Tooltip title={inputType.description}>
                                                    <span>{`${inputType.description.substring(0, 30)}...`}</span>
                                                </Tooltip>
                                            ) : (
                                                inputType.description
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <Switch
                                                    checked={editableInputType.required}
                                                    onChange={(e) => setEditableInputType({
                                                        ...editableInputType,
                                                        required: e.target.checked
                                                    })}
                                                    disabled={editableInputType.internal} // Disable if internal is true
                                                />
                                            ) : (
                                                inputType.required ? "კი" : "არა"
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <Switch
                                                    checked={editableInputType.internal}
                                                    disabled={editableInputType.hasFile || editableInputType.hasDeadline}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            internal: e.target.checked,
                                                            required: e.target.checked ? false : editableInputType.required, // Automatically uncheck if internal is checked
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.internal ? "კი" : "არა"
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id && inputType.type !== 1 ? (
                                                <Select
                                                    value={editableInputType.type}
                                                    onChange={(e) => setEditableInputType({
                                                        ...editableInputType,
                                                        type: e.target.value
                                                    })}
                                                    fullWidth
                                                    displayEmpty
                                                    margin="normal"
                                                >
                                                    <MenuItem value="0">სტანდარტული</MenuItem>
                                                    <MenuItem value="2">დიდი</MenuItem>
                                                    <MenuItem value="5">თარიღი</MenuItem>
                                                    <MenuItem value="6">ტელეფონი</MenuItem>
                                                    <MenuItem value="7">ელ-ფოსტა</MenuItem>
                                                </Select>
                                            ) : (
                                                inputType.integration === 2 ? "საჯარო რეესტრის ველი" :
                                                    inputType.type === 0 ? 'სტანდარტული' :
                                                        inputType.type === 2 ? 'დიდი' :
                                                            inputType.type === 6 ? 'ტელეფონი' :
                                                                inputType.type === 7 ? 'ელ-ფოსტა' :
                                                                    inputType.type === 5 ? 'თარიღი' :
                                                                        'ცნობარი'
                                            )}


                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id && inputType.type !== 1 ? (
                                                <Switch
                                                    checked={editableInputType.hasDeadline}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            hasDeadline: e.target.checked,
                                                            required: e.target.checked ? false : editableInputType.required,
                                                            internal: e.target.checked ? true : editableInputType.internal
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.hasDeadline ? "კი" : "არა"
                                            )}


                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id && inputType.type !== 1 ? (
                                                <Switch
                                                    checked={editableInputType.hasFile}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            hasFile: e.target.checked,
                                                            required: e.target.checked ? false : editableInputType.required,
                                                            internal: e.target.checked ? true : editableInputType.internal
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.hasFile ? "კი" : "არა"
                                            )}


                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id && inputType.type !== 1 ? (
                                                <Switch
                                                    disabled={editableInputType.hasFile || editableInputType.hasDeadline}
                                                    checked={editableInputType.unicId}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            unicId: e.target.checked,


                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.unicId ? "კი" : "არა"
                                            )}


                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <Switch
                                                    checked={editableInputType.visibleOnTableForUser}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            visibleOnTableForUser: e.target.checked,
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.visibleOnTableForUser ? "კი" : "არა"
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEditing === inputType.id ? (
                                                <Switch
                                                    checked={editableInputType.visibleOnTable}
                                                    onChange={(e) => {
                                                        setEditableInputType({
                                                            ...editableInputType,
                                                            visibleOnTable: e.target.checked,
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                inputType.visibleOnTable ? "კი" : "არა"
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {inputType.canBeDeleted ? "კი" : "არა"}
                                        </TableCell>

                                        <TableCell
                                            style={{position: 'sticky', right: 0, background: 'white', zIndex: 2}}>
                                            {isEditing === inputType.id ? (
                                                <div style={{display: "flex"}}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleSave(inputType.id)}
                                                        style={{marginRight: 10}}
                                                    >
                                                        შენახვა
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={cancelEdit}
                                                    >
                                                        გაუქმება
                                                    </Button>
                                                </div>
                                            ) : (
                                                <div style={{display: "flex"}}>
                                                    {!identificationFields.includes(inputType.title) && (
                                                        <>
                                                            <Tooltip
                                                                title={inputType.integration === 2 ? "საჯარო რეესტრის ველი არ არის რედაქტირებადი" : ""}>
                                                                <span>
                                                                    <Button
                                                                        variant="contained"
                                                                        onClick={() => handleEdit(inputType)}
                                                                        disabled={isEditing != null || inputType.integration === 2}
                                                                    >
                                                                        რედაქტირება
                                                                    </Button>
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip
                                                                title={inputType.canBeDeleted ? "შესაყვანი ველის წაშლა შეუძლებელია" : ""}>
                                                                <div
                                                                    style={{cursor: inputType.canBeDeleted ? "not-allowed" : "pointer"}}>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="error"
                                                                        onClick={() => openDeleteModal(inputType.id)}
                                                                        style={{marginLeft: '10px'}}
                                                                        disabled={isEditing != null || (inputType.canBeDeleted && !passwordEntered)}
                                                                    >
                                                                        წაშლა
                                                                    </Button>
                                                                </div>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Paper>

                <Dialog
                    open={open}
                    onClose={onClose}
                    fullWidth
                    maxWidth="md"
                    scroll="paper"
                >

                    <DialogContent dividers style={{padding: '20px', maxHeight: '80vh'}}>
                        <AddNewInputTypeFormForAll onAdd={refreshGlobalInputTypes}/>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openDict}
                    onClose={onCloseDict}
                    fullWidth
                    maxWidth="md"
                    scroll="paper"
                >

                    <DialogContent dividers style={{padding: '20px', maxHeight: '80vh'}}>
                        <DictionaryTypeAdder onAdd={refreshDictonaries}/>
                    </DialogContent>
                </Dialog>

            </Container>
            <ConfirmationModal
                isOpen={isDeleteModalOpen}
                onRequestClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }

            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={confirmSubmit}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
            <ConfirmationModal
                isOpen={isDropdownModalOpen}
                onRequestClose={() => setIsDropdownModalOpen(false)}
                onConfirm={confirmDropdownSubmit}
            />

            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>
    );
};

export default AddInputForm;